module.exports = __webpack_public_path__ + "img/bg_5.116c5131.png";